import axios from "axios";
import Modal, { ModalHeader, ModalBody, ModalFooter } from "../Modal";
import { ReactTabulator } from "react-tabulator";
import Loader from "../Loader";
import { useEffect, useState } from "react";
import './RLookUp.scss';

export default function RLookUp({
  id,
  variables,
  variableIsStringify,
  callBackDataHandler,
  modalHandler,
  fieldName,
  DarkColorMode
                                }) {

  const  [modalIsOpen, setModalIsOpen] = modalHandler;
  const [tableData, setTableData] = useState();

  let HOST = localStorage.getItem("apiUrl");
  useEffect(() => {

    const conditionObject =
      (variables && !variableIsStringify) ? makeConditionObject(variables) :
        (variables && variableIsStringify) ? variables:
        undefined;
    axios({
      method: "GET",
      url: `${HOST}/RLookup_Table/`,
      params: { kmo: localStorage.getItem("kmo"), rlookupId: id, condition:conditionObject },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((response) => {
        setTableData(response.data);
      })
      .catch((error) => {
        console.log(error.message);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const [modalIsOpen, setModalIsOpen] = useContext(FormContext);

  function modalCallback({ isOpen }) {

    setModalIsOpen(isOpen);
  }

  const [selectedRow, setSelectedRow] = useState();
  function rowClickHandler(e, row) {
    setSelectedRow(row);
  }

  function lookupSubmitHandler(selectedRow) {
    setTableData();
    axios({
      method: "GET",
      url: `${HOST}/RLookup_Data/`,
      // params: { kmo: localStorage.getItem("kmo"), id: selectedRow.getData() },
      params: {
        kmo: localStorage.getItem("kmo"),
        rlookupId: id,
        recordId: selectedRow.getData().primaryKey,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((response) => {
        setModalIsOpen(false);
        callBackDataHandler(response.data);

        // console.log(variables)
        // console.log(fieldName)
        // مهندس طاهری اومد گفت توی هر درخوسا تباید بهم بگی اون وریبلز ها چه مقداری دارن
        // منم میخوام اینجا اونا رو بریزم توی سشن استوریج
        // خب ممکنه  از قبل پر باشه. خب بهش اضافه میکنم. و اسمشو میزارم کاندیشن آبجکت دیتا
        //پس
        setPickedValueToLocalStorage(response.data)

      })
      .catch((error) => {
        console.log(error.message);
      });
  }
  // این تابع مقداری که کاربر در آرلوکاپ انتخاب میکنه میبره توی لوکال استوریج میشونه تا بعدا موقعی که نیاز هست وریبل ها رو بفرستیم ازش استفاده کنیم
  function setPickedValueToLocalStorage(data) {

    let conditionObjectData = sessionStorage.getItem("conditionObjectData");

    if (conditionObjectData !== null) {
      const temp = JSON.parse(conditionObjectData);
      temp[fieldName] = data[fieldName];
      const stringifyTemp = JSON.stringify(temp)
      sessionStorage.setItem("conditionObjectData", (stringifyTemp))
    } else {

      let temp = {};
      temp[fieldName] = data[fieldName];
      const stringifyTemp = JSON.stringify(temp)
      sessionStorage.setItem("conditionObjectData", (stringifyTemp))
    }
  }
  // در ادامه تابع بالایی که  اسمش اینه:
  function makeConditionObject(variables) {

    const temp = {};
    if (variables !== '') {
      let conditionObjectData = JSON.parse(sessionStorage.getItem("conditionObjectData"));
      const variablesArray = variables.split(',');
      variablesArray.forEach((value, index) => {
        temp[value] = conditionObjectData!==null ? conditionObjectData[value] : "";

      })
    }
    return JSON.stringify(temp)
  }
  const rowDoubleClickHandler = (e, row) => {
    // 'e' is the event object, and 'row' is the Tabulator row object
    //console.log('Row double-clicked:', row.getData());
    // Add your custom logic for double-click handling here

    //setSelectedRow(row)
    lookupSubmitHandler(row)
  };


  return (
    <Modal isOpen={modalIsOpen} modalCallback={modalCallback} DarkColorMode ={DarkColorMode}

    >
      <ModalHeader
        title={tableData === undefined ? "در حال بارگذاری" : tableData.title}
        // setModalIsOpen(false);
      />
      <ModalBody>
        {tableData === undefined ? (
          <Loader type="inline" />
        ) : (
          <ReactTabulator
            columns={tableData.columns}
            data={tableData.data}
            options={{ selectable: 1, height: "50vh" }}
            events={{ rowClick: rowClickHandler,
              rowDblClick: rowDoubleClickHandler,
            }}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btnCustom btnSubmit"
          onClick={() => lookupSubmitHandler(selectedRow)}
        >
          انتخاب
        </button>
      </ModalFooter>
    </Modal>
  );
}
